import React from 'react'
import CrudPaquetes from './CrudPaquetes';
import { titulos, notificaciones } from './Objetos/constantes';

const CatalogoPaquetes = () => {
    return (
        <>
            <CrudPaquetes
                titulos={titulos}
                notificaciones={notificaciones}
            />
        </>
    )
}

export default CatalogoPaquetes
